import React, { useRef, useState } from "react";
import api, { API } from "@/lib/api";
import { Camera, Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function PhotoUploader({ value, onChange, label = "Upload Photo", testid = "photo-uploader" }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange?.(data.path);
      toast.success("Photo uploaded");
    } catch (e) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  if (value) {
    return (
      <div className="relative inline-block" data-testid={`${testid}-preview`}>
        <img
          src={`${API}/files?path=${encodeURIComponent(value)}`}
          alt="upload"
          className="w-32 h-32 object-cover rounded-md border border-zinc-200"
        />
        <button
          type="button"
          onClick={() => onChange?.(null)}
          className="absolute -top-2 -right-2 bg-zinc-900 text-white rounded-full p-1"
          data-testid={`${testid}-remove`}
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    );
  }

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(e) => handle(e.target.files?.[0])}
        data-testid={`${testid}-input`}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        className="flex flex-col items-center justify-center min-h-[120px] w-full max-w-xs border-2 border-dashed border-zinc-300 bg-zinc-50 hover:bg-zinc-100 rounded-lg transition-colors p-4 btn-press"
        data-testid={`${testid}-button`}
      >
        {busy ? <Loader2 className="w-6 h-6 animate-spin text-zinc-500" /> : <Camera className="w-6 h-6 text-zinc-500" />}
        <span className="mt-2 text-sm text-zinc-600">{busy ? "Uploading..." : label}</span>
      </button>
    </div>
  );
}
